<template>
  <v-row>
    <v-col cols="12">
      <v-layout row wrap>
        <v-flex v-for="(item, index) in levels" :key="index" xs12 sm6 md3>
          <v-checkbox
            :color="getTagColor(item)"
            :label="item"
            :value="item"
            :dark="darkMode"
            v-model="listLocal"
            hide-details
          >
          </v-checkbox>
        </v-flex>
      </v-layout>
    </v-col>
  </v-row>
  <!--  CALL COMPONENT FROM PARENT EXAMPLE -- 
              <AthletesDropdown v-on:change-athlete="onChangeAthlete"/>
              import AthletesDropdown from "../shared/athletes_dropdown_example.vue";-->
</template>

<script>
1;
//import { mapGetters } from "vuex";
import { getTagColor } from "../../mixins/getTagColor.js";

export default {
  props: ["parentList", "darkMode"],
  model: {
    prop: "parentList",
    event: "parentListChange"
  },
  mixins: [getTagColor],
  data() {
    return {
      levels: ["Begginer", "Junior", "Advanced", "Unleveled"]
    };
  },
  computed: {
    listLocal: {
      get: function() {
        return this.parentList;
      },
      set: function(value) {
        this.$emit("parentListChange", value);
      }
    }
  },
  created() {},
  mounted() {}
};
</script>
